import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

	// Hide search form in navbar-main on scroll down, show on scroll up (100px accumulated threshold).
	let lastScrollY = window.scrollY;
	let scrollUpTotal = 0;
	let isVisible = true;
	let hideTimer = null;
	window.addEventListener("scroll", () => {
		const target = document.querySelector('.navbar-main [class*="block--mtouton-theme-exposedformproducts-index-pricepage-products"]');
		const topBar = document.querySelector('#top-bar');
		const currentScrollY = window.scrollY;
		const delta = currentScrollY - lastScrollY;

		if (delta < -2) {
			// Scrolling up: accumulate and cancel any pending hide
			scrollUpTotal += -delta;
			clearTimeout(hideTimer);
			if (currentScrollY <= 50 || scrollUpTotal >= 100) {
				isVisible = true;
				target?.classList.remove('js-scroll-hidden');
				topBar?.classList.remove('search-hidden');
			}
		} else if (delta > 10) {
			// Scrolling down (ignore small deltas to avoid inertia/bounce triggers)
			scrollUpTotal = 0;
			if (isVisible && currentScrollY > 50) {
				clearTimeout(hideTimer);
				hideTimer = setTimeout(() => {
					isVisible = false;
					target?.classList.add('js-scroll-hidden');
					topBar?.classList.add('search-hidden');
				}, 400);
			}
		}

		lastScrollY = currentScrollY;
	}, { passive: true });

})();

// Sync flexslider nav/paging color with active slide's button-light/button-dark class.
(function ($) {
	function syncSliderNavColor($slider, slideIndex) {
		const $slide = $slider.find('ul.slides > li').eq(slideIndex);
		const isLight = $slide.find('.slideButton').hasClass('button-light');
		$slider.toggleClass('slider-nav-light', isLight);
		$slider.toggleClass('slider-nav-dark', !isLight);
	}

	Drupal.behaviors.sliderNavColor = {
		attach(context) {
			$('.flexslider', context).each(function () {
				const $slider = $(this);
				$slider.on('init', (_event, slider) => syncSliderNavColor($slider, slider.currentSlide));
				$slider.on('after', (_event, slider) => syncSliderNavColor($slider, slider.currentSlide));
			});
		},
	};
})(jQuery);

(function (Drupal, once) {
	Drupal.behaviors.producerCategoryTree = {
		attach(context) {
			if (!window.matchMedia('(max-width: 991.98px)').matches) {
				return;
			}

			once('producer-category-tree-mobile', '.producer__dropdown--l1', context).forEach((dropdown) => {
				dropdown.removeAttribute('open');
			});
		},
	};

	const TRANSITION_MS = 250;

	Drupal.behaviors.producerCategoryTreeAnimation = {
		attach(context) {
			once('producer-category-tree-animation', '.producer__dropdown', context).forEach((details) => {
				const summary = details.querySelector(':scope > summary');
				const collapsible = details.querySelector(':scope > .producer__collapsible');

				if (!summary || !collapsible) {
					return;
				}

				let timer = null;
				// Tracks the target state across a click, independent of the
				// `open` attribute: while an animation is in flight, `open`
				// still reflects where it started, not where a rapid second
				// click wants it to end up.
				let isOpen = details.open;

				summary.addEventListener('click', (event) => {
					event.preventDefault();
					window.clearTimeout(timer);

					if (isOpen) {
						isOpen = false;
						// Closing: keep the content rendered while we animate its
						// height down to 0, then remove [open]. Timed with
						// setTimeout (not `transitionend`) so the details element
						// always finishes closing even if the browser skips or
						// interrupts the visual transition.
						collapsible.style.maxHeight = `${collapsible.scrollHeight}px`;
						void collapsible.offsetHeight; // force reflow before animating.
						collapsible.style.maxHeight = '0px';

						timer = window.setTimeout(() => {
							details.open = false;
							collapsible.style.maxHeight = '';
						}, TRANSITION_MS);
					} else {
						isOpen = true;
						// Opening: render the content first so scrollHeight is
						// measurable, start from 0, then animate up to its
						// natural height.
						details.open = true;
						collapsible.style.maxHeight = '0px';
						void collapsible.offsetHeight; // force reflow before animating.
						collapsible.style.maxHeight = `${collapsible.scrollHeight}px`;

						timer = window.setTimeout(() => {
							collapsible.style.maxHeight = '';
						}, TRANSITION_MS);
					}
				});
			});
		},
	};
})(Drupal, once);
